import { NumberField } from '../../atoms';
import { FORM_CLASSIFIERS_TAX_EDIT } from '../../constants/formKeys';
import {
  getClassifiersTaxChange,
  getClassifiersTaxItem,
  getClassifiersTaxItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { classifierTaxEditFields } from '../../constants/classifier';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'taxTitle',
  formKey: FORM_CLASSIFIERS_TAX_EDIT,
  fields: [
    {
      name: classifierTaxEditFields.TAX,
      label: 'fieldTax',
      component: NumberField,
      className: 'date-field',
      isFloat: true,
      min: 0.01,
      step: 0.01,
    },
  ],
  fetchAction: actions.fetchClassifierTax,
  changeAction: actions.changeClassifierTax,
  getChangeSelector: getClassifiersTaxChange,
  getItemSelector: getClassifiersTaxItem,
  getInitialValues: (state) => ({
    [classifierTaxEditFields.TAX]: getClassifiersTaxItemData(state),
  }),
});
